// currency symbol lookup with graceful placement
const SYMBOLS = {
  USD: "$", EUR: "€", GBP: "£", INR: "₹", JPY: "¥", CNY: "¥", AUD: "A$", CAD: "C$",
  CHF: "CHF", AED: "د.إ", SAR: "﷼", SGD: "S$", HKD: "HK$", ZAR: "R", BRL: "R$",
  MXN: "$", SEK: "kr", NOK: "kr", NZD: "NZ$", RUB: "₽", KRW: "₩", TRY: "₺",
  MYR: "RM", QAR: "ر.ق", KWD: "د.ك",
};
// currencies whose symbol reads better as a trailing code
const SUFFIX = new Set(["AED", "SAR", "QAR", "KWD", "SEK", "NOK"]);

function fmt(amount) {
  return Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function money(amount, currency = "USD") {
  const n = fmt(amount);
  if (SUFFIX.has(currency)) return `${n} ${currency}`;
  const sym = SYMBOLS[currency] || "";
  return `${sym}${n}`;
}

// plain formatted number (no symbol) — used for mixed-currency aggregates
export function num(amount) {
  return fmt(amount);
}

export function symbolFor(currency) {
  return SYMBOLS[currency] || currency;
}
